export const alerts = [
  {
    id: 'alert-001',
    type: 'URGENT RECALL',
    title: 'Ambrosia Brands Recalls All Rosabella Moringa Capsules',
    date: '2026-02-13',
    source: 'FDA',
    summary: 'Urgent nationwide recall issued for Rosabella brand Moringa capsules due to potential Salmonella contamination. Consumers should stop using immediately.',
    link: 'https://www.fda.gov/safety/recalls-market-withdrawals-safety-alerts/ambrosia-brands-llc-recalls-rosabella-moringa-capsules-because-possible-health-risk',
    affectedProducts: ['Rosabella Organic Moringa Capsules 60ct', 'Rosabella Organic Moringa Capsules 120ct'],
    riskLevel: 'High'
  },
  {
    id: 'alert-002',
    type: 'OUTBREAK ALERT',
    title: 'CDC Investigation: Salmonella Outbreak Linked to Moringa',
    date: '2026-02-26',
    source: 'CDC',
    summary: 'The CDC is investigating a multistate outbreak of Salmonella linked to moringa powder capsules. 15 reported cases across 4 states.',
    link: 'https://www.cdc.gov/salmonella/outbreaks/moringacapsules-02-26/index.html',
    riskLevel: 'High'
  },
  {
    id: 'alert-003',
    type: 'STATE WARNING',
    title: 'Illinois Public Health Issues Warning on Bulk Moringa Powder',
    date: '2026-02-13',
    source: 'IDPH',
    summary: 'Illinois health officials warn consumers about bulk moringa powder sold at local health food markets potentially containing heavy metals.',
    link: 'https://dph.illinois.gov/content/soi/idph/en/resource-center/news/2026/february/release-20260213.html',
    riskLevel: 'Medium'
  }
];

export const news = [
  {
    id: 'news-001',
    title: 'New Outbreak Traced to Moringa Capsules Under Investigation',
    author: 'Food Safety News Desk',
    date: '2026-02-27',
    category: 'Investigation',
    image: 'https://images.unsplash.com/photo-1515543904379-3d757afe9c6c?q=80&w=2000&auto=format&fit=crop',
    excerpt: 'Federal agencies have launched a coordinated effort to trace the source of extensively drug-resistant Salmonella found in recent supplement batches.',
    content: 'Full article content would go here...'
  },
  {
    id: 'news-002',
    title: 'Understanding Supplement Regulations: What Consumers Need to Know',
    author: 'Dr. Sarah Chen',
    date: '2026-02-20',
    category: 'Education',
    image: 'https://images.unsplash.com/photo-1584362917165-526a968579e8?q=80&w=2000&auto=format&fit=crop',
    excerpt: 'Unlike prescription drugs, dietary supplements like moringa are not approved by the FDA for safety and effectiveness before being marketed.',
    content: 'Full article content...'
  },
  {
    id: 'news-003',
    title: 'Legal Update: Class Action Lawsuit Filed Against Manufacturer',
    author: 'Legal Correspondent',
    date: '2026-02-18',
    category: 'Legal',
    image: 'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=2000&auto=format&fit=crop',
    excerpt: 'A class action lawsuit has been filed following the hospitalization of three individuals who consumed contaminated supplements.',
    content: 'Full article content...'
  }
];

export const products = [
  {
    id: 'prod-001',
    brand: 'Rosabella',
    product: 'Moringa Powder Capsules (Ambrosia Brands LLC)',
    status: 'RECALLED',
    safetyRating: 'F',
    lastTested: '2026-02-13',
    notes: 'Recalled for Salmonella. Various lot codes with 2027 expiration dates.'
  },
  {
    id: 'prod-002',
    brand: 'Pura Vida Moringa',
    product: 'Pure Moringa Leaf Powder',
    status: 'SAFE',
    safetyRating: 'A',
    lastTested: '2026-01-15',
    notes: 'Passed heavy metal and microbial testing.'
  },
  {
    id: 'prod-004',
    brand: 'Why Not Natural',
    product: 'Pure Organic Moringa Green Superfood Capsules',
    status: 'RECALLED',
    safetyRating: 'F',
    lastTested: '2026-02-26',
    notes: 'Recalled for Salmonella. Lot # A25G051, 07/2028 expiration.'
  },
  {
    id: 'prod-005',
    brand: 'Live it Up',
    product: 'Super Greens (Original and Wild Berry)',
    status: 'RECALLED',
    safetyRating: 'F',
    lastTested: '2026-02-26',
    notes: 'Recalled for Salmonella. Lots beginning with "A", expiration 08/2026 to 01/2028.'
  },
  {
    id: 'prod-006',
    brand: 'Food To Live',
    product: 'Organic Moringa Leaf Powder / Supergreens Powder Mix',
    status: 'RECALLED',
    safetyRating: 'F',
    lastTested: '2026-02-26',
    notes: 'Recalled for Salmonella contamination.'
  },
  {
    id: 'prod-007',
    brand: 'Africa Imports',
    product: 'Organic Moringa Leaf Powder',
    status: 'RECALLED',
    safetyRating: 'F',
    lastTested: '2026-02-26',
    notes: 'Recalled for Salmonella contamination.'
  },
  {
    id: 'prod-008',
    brand: 'Member\'s Mark',
    product: 'Super Greens Dietary Supplement Powder',
    status: 'RECALLED',
    safetyRating: 'F',
    lastTested: '2026-02-26',
    notes: 'Recalled for Salmonella contamination.'
  }
];